import { reactMount } from '@/lib/reactMount'
import { useRef } from 'react'
import { Disclosure, DisclosureButton } from '@headlessui/react'
import { PlusIcon } from '@heroicons/react/24/solid'

// Empty State Component
// Empty State Component
// Empty State Component
const EmptyState = ({ message = 'No data found.' }) => (
  <div className='w-full flex justify-center items-center gap-2'>
    <p className='text-gray-500 text-lg'>{message}</p>
  </div>
)

// Team Member Card Component
// Team Member Card Component
// Team Member Card Component
const TeamMemberCard = ({ member }) => {
  return (
    <article className='space-y-3 w-full max-w-[360px] sm:max-w-[340px] mx-auto'>
      {/* Profile Picture */}
      <figure className={`relative flex w-full aspect-square rounded-lg overflow-hidden ${!member.Media?.Image?.Url ? 'bg-default-200' : ''}`}>
        {member.Media?.Image?.Url && (
          <img
            src={member.Media.Image.Url}
            alt={member.Media.Image.Alt || `${member.Name} profile picture`}
            className='absolute inset-0 w-full h-full object-cover'
          />
        )}
      </figure>

      {/* Team Member Information */}
      <div className='space-y-1'>
        <h3 className='text-xl text-default-900 font-extrabold tracking-tight'>
          {member.Name}
        </h3>
        <p className='text-default-900 text-base font-smibold tracking-tight'>
          {member.Role}
        </p>
        {member.PhoneNumber && (
          <a href={`tel:${member.PhoneNumber}`} className='text-xs font-extrabold'>
            {member.PhoneNumber}
          </a>
        )}
      </div>
    </article>
  )
}

// Team Member Grid Component
const TeamMemberGrid = ({ members }) => (
  <div className='grid grid-cols-1 gap-x-5 gap-y-8 sm:grid-cols-2 lg:grid-cols-3 pt-1 pb-7 px-6'>
    {members.map((member, index) => (
      <TeamMemberCard key={`${member.name}-${index}`} member={member} />
    ))}
  </div>
)

// Department Section Component
const DepartmentSection = ({ department, index }) => (
  <Disclosure as='section' defaultOpen={index === 0}>
    {({ open }) => (
      <>
        <DisclosureButton className='group flex w-full items-start justify-between text-left gap-2 text-primary-950 tracking-tight py-7'>
          <span className='text-xs opacity-50 font-extrabold pt-1'>0{index + 1}</span>
          <span className='flex-1 text-xl/7 font-extrabold text-pretty'>{department.Team}</span>
          <span className='flex h-7 items-center'>
            <PlusIcon aria-hidden='true' className={`ease-out duration-400 size-5 _icon-stroke ${open ? 'rotate-45' : ''} text-[--faq-icon]`} />
          </span>
        </DisclosureButton>
        <div className={`grid ease-out duration-400 ${open ? 'grid-rows-[1fr]' : 'grid-rows-[0fr]'}`}>
          <div className={`overflow-hidden ease-in duration-400 ${open ? 'opacity-100' : 'opacity-0'}`}>
            <TeamMemberGrid members={department.Members} />
          </div>
        </div>
      </>
    )}
  </Disclosure>
)

// Department List Component
const DepartmentList = ({ departments }) => (
  <div className='divide-y-2 divide-default-200'>
    {departments.map((department, index) => (
      <DepartmentSection
        index={index}
        key={department.Team}
        department={department}
        isOpen={index === 0}
      />
    ))}
  </div>
)

// Main OurTeamPage Component
export const OurTeamPage = ({ dataset, umbraco }) => {
  const umbracoRef = useRef(umbraco || JSON.parse(dataset.umbraco))
  umbraco ||= umbracoRef.current
  const departments = umbraco.Departments

  return (
    <>
      <div className='relative isolate py-16 md:px-4 lg:px-10 xl:px-24'>
        <div className='mx-auto max-w-[1042px] px-4 xl:px-3 space-y-16'>
          {departments.length > 0 && (
            <DepartmentList departments={departments} />
          )}
          {departments.length === 0 && (
            <EmptyState message='No team members found.' />
          )}
        </div>
      </div>
    </>
  )
}

reactMount('OurTeamPage', OurTeamPage)
